import { createContext, type ReactNode, use, useState } from "react";

interface ApiHealthContextType {
    isApiHealthy: boolean;
    setIsApiHealthy: (healthy: boolean) => void;
}

const ApiHealthContext = createContext<ApiHealthContextType | undefined>(undefined);

export function ApiHealthProvider({ children }: { children: ReactNode }) {
    const [isApiHealthy, setIsApiHealthy] = useState(true);

    return (
        <ApiHealthContext value={{ isApiHealthy, setIsApiHealthy }}>{children}</ApiHealthContext>
    );
}

export function useApiHealthContext() {
    const context = use(ApiHealthContext);
    if (context === undefined) {
        throw new Error("useApiHealthContext must be used within an ApiHealthProvider");
    }
    return context;
}
